// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectorOption {
  padding: 5px 8px;
  border: 1px solid #d9d9d9;
  font-weight: 700;
  font-size: 14px;
  line-height: normal;
  color: #3f3f46;
  border-radius: 6px;
  cursor: pointer;
  display: inline-block;
  background: transparent;
}
.selectorOption.active {
  color: #fff;
  background-color: #3f3f46;
  border: 1px solid #3f3f46;
}
.has-error .selectorOption {
  background-color: rgba(255, 56, 96, 0.05);
}
.has-error .selectorOption.active {
  color: #fff;
  background-color: #3f3f46;
}

.selector-horizontal {
  overflow-x: auto;
  white-space: nowrap;
}

.selector-vertical .selectorOption {
  display: block;
}`, "",{"version":3,"sources":["webpack://./packages/react-hook-schema/standard/src/lib/selector.scss"],"names":[],"mappings":"AAGA;EACE,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAToB;EAUpB,kBAAA;EACA,eAAA;EACA,qBAAA;EAEA,uBAAA;AAHF;AAIE;EAEE,WAAA;EACA,yBAlBkB;EAmBlB,yBAAA;AAHJ;AAME;EACE,yCAAA;AAJJ;AAOI;EAEE,WAAA;EACA,yBA7BgB;AAuBtB;;AAWA;EACE,gBAAA;EACA,mBAAA;AARF;;AAYE;EACE,cAAA;AATJ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
